<template>
    <transition name="fade-scale">
        <div class="results-modal" v-show="open">
            <div class="results-overlay" @click="close"></div>
            <table class="result-list">
                <thead>
                <tr>
                    <th class="result-list-heading">Resource</th>
                    <th class="result-list-heading">Endpoint</th>
                    <th class="result-list-heading">URI</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(result, index) in results"
                    :key="index"
                    class="result-list-row"
                    @click="showResult(result)"
                    @keydown.prevent.space="showResult(result)"
                    @keydown.prevent.enter="showResult(result)"
                    tabindex="0">
                    <td class="result-list-cell">{{ result.resource.name }}</td>
                    <td class="result-list-cell">{{ result.name }}</td>
                    <td class="result-list-cell result-list-cell-uri">{{ result.uri }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </transition>
</template>

<script>
  import Fuse               from 'fuse.js';
  import { ROUTE_RESOURCE } from '../router';

  export default {
    name: 'ResultsModal',

    props: {
      term: {
        type:    String,
        default: 'index',
      },
    },

    data () {
      return {
        results: [],
        open:    false,
      };
    },

    watch: {
      term () {
        this.open    = this.term.length > 0;
        this.results = this.search(this.term, this.$api.endpoints);
      },
    },

    methods: {
      /**
       * Searches for an endpoint
       *
       * @param   {string}     term
       * @param   {Endpoint[]} endpoints
       * @returns {Endpoint[]}
       */
      search ( term, endpoints ) {
        if ( term === '' ) {
          return [];
        }

        const options = {
          threshold: 0.35,
          keys:      [
            {
              name:   'caption',
              weight: 0.4,
            },
            {
              name:   'name',
              weight: 0.3,
            },
            {
              name:   'summary',
              weight: 0.2,
            },
            {
              name:   'description',
              weight: 0.1,
            },
          ],
        };

        const fuse = new Fuse(endpoints, options);

        // Slice the results to 10 max
        return fuse.search(term).slice(0, 10);
      },

      /**
       * Shows a search result
       *
       * @param {Endpoint} result
       */
      showResult ( result ) {
        this.$router.replace({
          name:   ROUTE_RESOURCE,
          params: {
            slug: result.resource.slug,
          },
          hash:   `#endpoint-${ result.slug }`,
        });
        this.results = [];
      },

      close () {
        this.open = false;
      },
    },
  };
</script>

<style scoped>
    .results-modal {
        position:      absolute;
        left:          1rem;
        top:           100%;
        padding:       1rem;
        border-radius: 3px;
        background:    var(--color-white);
        color:         var(--color-gray-darker);
        box-shadow:    0 2px 5px rgba(0, 0, 0, 0.1),
                       0 5px 15px rgba(0, 0, 0, 0.05);
        z-index:       3;
    }

    .result-list {
        position:        relative;
        z-index:         4;
        border-collapse: collapse;
    }

    .result-list-heading {
        text-align:  left;
        font-weight: normal;
        color:       var(--color-gray-medium);
    }

    .result-list-heading,
    .result-list-cell {
        padding: 0.5rem;
    }

    .result-list-cell {
        cursor:     pointer;
        transition: background 125ms;
    }

    .result-list-cell:not(:first-child):not(:last-child) {
        border-left:  1px solid var(--color-gray-light);
        border-right: 1px solid var(--color-gray-light);
    }

    .result-list-row:not(:last-child) .result-list-cell {
        border-bottom: 1px solid var(--color-gray-light);
    }

    .result-list-cell-uri {
        font-family: var(--font-family-monospace);
        font-size:   1.1rem;
    }

    .result-list-row:hover .result-list-cell,
    .result-list-row:focus .result-list-cell {
        background: rgba(0, 0, 0, 0.025);
    }

    .results-overlay {
        position:   fixed;
        top:        0;
        left:       0;
        width:      100vw;
        height:     100vh;
        background: rgba(255, 255, 255, 0.15);
        z-index:    2;
    }
</style>
